module.exports = __webpack_public_path__ + "media/wilton-greens-is.73f98284.mp4";